  /* Accordion JS start */
  // console.log("accordion js");
  const accordionSections = document.querySelectorAll('.collection-accordian-column');
  
  accordionSections.forEach(section => {
      const header = section.querySelector('.accordions');
      const content = section.querySelector('.accordion-content');
      const icon = section.querySelector('.accordion-icon');
      const hiddenclass = section.querySelector('.collection-accordion-content');
    
    // console.log("accordion clicked 0");

    
      header.addEventListener('click', () => {
        // console.log("accordion clicked 1");
          header.classList.toggle('is-open');
          hiddenclass.classList.toggle('is--hiddenn');
          if (header.classList.contains('is-open')) {
              icon.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0802/4342/5575/files/Accordian-Arrow-up.png?v=1695144789" alt="Up Arrow" style="width: 12px;">';
          } else {
              icon.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0802/4342/5575/files/Accordian-Arrow-down.png?v=1695144751" alt="Up Arrow" style="width: 12px;">';
          }
      });
  });
  /* Accordion JS end */
 
 $( document ).ready(function() {
    $('.filter-icon-wrapper .filter-icon').on('click', function(){
      event.stopPropagation();
      $('.filter-Section').toggleClass("filter-hidden");
    });
    $('.filter-Section').on('click', function(){
      event.stopPropagation();
    });
  });
  $(document).on("click", function () {
    $('.filter-Section').addClass("filter-hidden");
  });
  $('.collection-filter-close-icon').on('click', function(){
    $('.filter-Section').toggleClass("filter-hidden");
  });

 $(document).ready(function(){ 
  $(".js_radio").on('click', function(event) {
    var newTags = [];
    $(this).prop("checked", true) 
    let chandle = $(this).attr('data-chandle');
    $('.js_radio:checked').each(function() {
      let test = $(this).attr('data-tag-name');
      
      
      newTags.push(test)
       
      
    });
  
    if (newTags.length) {
      var query = newTags.join('+');
       
      window.location.href = $('<a href="/collections/'+chandle+'/tag" title="Show products matching tag tag">tag</a>').attr('href').replace('/' + 'tag', '/' + query);
    } else {
  
      window.location.href = '/collections/all';
  
    }
    
});
   

   
   });

   $(document).ready(function(){
  
  $(document).on('click', '.js-product-atc', function (e) {

    e.preventDefault();
    var target = e.target;
    var data_id = $(this).attr("data-id");

    var quantity = $('.productquantityselect input[data-qty-id="'+data_id +'"]').val();

    $.ajax({
      url :   "/cart/add.js",
      method : "POST",
      dataType : "JSON",
      data : {id : data_id , quantity : quantity},
      success : function() {
        window.location = "/checkout";

      }
    });

  });
  


});